<template>
  <v-card
    class="approval-item-card justify-start rounded-0 pa-3"
    :class="{ 'approval-item-card--selected': selected }"
    data-testid="approvalItem-button-root"
    elevation="0"
    height="auto"
    outlined
    :ripple="false"
    @click="$emit('click')"
  >
    <div class="w-100 d-flex align-center justify-space-between py-1">
      <div class="d-flex flex-column align-start">
        <ChipAvatar
          :account="approver"
          :data-testid="'approvalItem-text-name'"
          hideBorder
        />
        <p
          class="ma-0 mt-2 caption blue-grey--text text--darken-1"
          data-testid="approvalItem-text-date"
        >
          {{ dynamicDateLabel }}
        </p>
      </div>

      <v-chip
        v-if="approval.status === APPROVAL_STATUS.REQUESTED"
        small
        color="blue lighten-2"
        data-testid="approvalItem-chip-statusRequested"
      >
        <v-icon left small color="blue">mdi-clock-outline</v-icon>

        <span class="caption blue--text text--darken-1">{{
          $t('routines.approval.request_status_requested')
        }}</span>
      </v-chip>

      <v-chip
        v-else-if="approval.status === APPROVAL_STATUS.APPROVED"
        color="green lighten-2"
        data-testid="approvalItem-chip-statusApproved"
        small
      >
        <v-icon left small color="green">mdi-check</v-icon>

        <span class="caption green--text text--darken-1">{{
          $t('common.approved')
        }}</span>
      </v-chip>

      <v-chip
        v-else-if="approval.status === APPROVAL_STATUS.REJECTED"
        color="red lighten-2"
        data-testid="approvalItem-chip-statusRejected"
        small
      >
        <v-icon left small color="red">mdi-close</v-icon>

        <span class="caption red--text text--darken-1">{{
          $t('routines.approval.rejected')
        }}</span>
      </v-chip>

      <span
        v-else
        class="caption font-weight-medium blue-grey--text text--darken-1"
        data-testid="approvalItem-text-status"
      >
        {{ statusLabel }}
      </span>
    </div>
  </v-card>
</template>

<script>
import { utils } from 'frontend-js-shared'

import ChipAvatar from '@/components/ChipAvatar.vue'

import { APPROVAL_STATUS } from './constants'

export default {
  name: 'ApprovalItem',

  components: {
    ChipAvatar,
  },

  props: {
    approval: {
      type: Object,
      required: true,
    },
    selected: Boolean,
  },

  data() {
    return {
      APPROVAL_STATUS,
    }
  },

  computed: {
    approver() {
      return this.approval?.approver || null
    },

    requestedDate() {
      return utils.dates.formatDate(
        this.approval?.createdAt,
        'MMM D YYYY, h:mm A'
      )
    },

    approvedDate() {
      return utils.dates.formatDate(
        this.approval?.statusUpdatedAt,
        'MMM D YYYY, h:mm A'
      )
    },

    dynamicDateLabel() {
      if (this.approval?.status === APPROVAL_STATUS.REQUESTED) {
        return this.$t('routines.approval.requested_on_with_date', {
          date: this.requestedDate,
        })
      }

      if (this.approval?.status === APPROVAL_STATUS.APPROVED) {
        return this.$t('routines.approval.approved_on_with_date', {
          date: this.approvedDate,
        })
      }

      if (this.approval?.status === APPROVAL_STATUS.REJECTED) {
        return this.$t('routines.approval.rejected_on_with_date', {
          date: this.approvedDate,
        })
      }

      return this.approvedDate
    },

    statusLabel() {
      if (this.approval?.status === APPROVAL_STATUS.REQUESTED) {
        return this.$t('routines.approval.request_status_requested')
      }

      if (this.approval?.status === APPROVAL_STATUS.APPROVED) {
        return this.$t('common.approved')
      }

      if (this.approval?.status === APPROVAL_STATUS.REJECTED) {
        return this.$t('routines.approval.rejected')
      }

      return this.approval?.status || '-'
    },
  },
}
</script>

<style lang="scss" scoped>
.approval-item-card {
  border: 1px solid $color-blue-grey-lighten2 !important;

  &:not(:first-of-type) {
    border-top: 0 !important;
  }

  &--selected {
    background-color: $color-blue-grey-lighten3 !important;

    &:focus:before {
      opacity: 0 !important;
    }
  }
}
</style>
